export default {
  init() {
    // JavaScript to be fired on all pages
    // Shrinking header
    $(window).scroll(function() {
        if ($(document).scrollTop() > 5) {
          $('.site-header').addClass('shrink');
        } else {
          $('.site-header').removeClass('shrink');
        }
    });

  
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* eslint-disable */

        
        // desktop - when we add class .dropdown-menu-right in list, we stick dropdown going left
        $('.desktop-navigation ul .dropdown-menu-right .dropdown-menu').addClass('dropdown-menu-right');


        var $hamburger = $(".hamburger");
        $hamburger.on("click", function(event) {
          $hamburger.toggleClass("is-active");
          $("body").toggleClass("menu-opened");
          //$(".header__wrapper-overlay-menu").toggleClass("opened");
          $(".brand").toggleClass("logo-show");
          $('.mobile-navigation').toggleClass('is-active');
        });



        $(document).ready(function () {

            /**
             * navigation.js
             *
             * Handles toggling the navigation menu for small screens and enables tab
             * support for dropdown menus.
             */
            ( function() {
              var container, button, menu, links, subMenus;

              container = document.getElementById( 'site-navigation' );
              if ( ! container ) {
                return;
              }

              button = container.getElementsByTagName( 'button' )[0];
              if ( 'undefined' === typeof button ) {
                return;
              }

              menu = container.getElementsByTagName( 'ul' )[0];

              // Hide menu toggle button if menu is empty and return early.
              if ( 'undefined' === typeof menu ) {
                button.style.display = 'none';
                return;
              }

              menu.setAttribute( 'aria-expanded', 'false' );
              if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
                menu.className += ' nav-menu';
              }

              button.onclick = function() {
                if ( -1 !== container.className.indexOf( 'toggled' ) ) {
                  container.className = container.className.replace( ' toggled', '' );
                  button.setAttribute( 'aria-expanded', 'false' );
                  menu.setAttribute( 'aria-expanded', 'false' );
                } else {
                  container.className += ' toggled';
                  button.setAttribute( 'aria-expanded', 'true' );
                  menu.setAttribute( 'aria-expanded', 'true' );
                }
              };

              // Get all the link elements within the menu.
              links    = menu.getElementsByTagName( 'a' );
              subMenus = menu.getElementsByTagName( 'ul' );

              // Set menu items with submenus to aria-haspopup="true".
              for ( var i = 0, len = subMenus.length; i < len; i++ ) {
                subMenus[i].parentNode.setAttribute( 'aria-haspopup', 'true' );
              }

              // Each time a menu link is focused or blurred, toggle focus.
              for ( i = 0, len = links.length; i < len; i++ ) {
                links[i].addEventListener( 'focus', toggleFocus, true );
                links[i].addEventListener( 'blur', toggleFocus, true );
              }

              /**
               * Sets or removes .focus class on an element.
               */
              function toggleFocus() {
                var self = this;

                // Move up through the ancestors of the current link until we hit .nav-menu.
                while ( -1 === self.className.indexOf( 'nav-menu' ) ) {

                  // On li elements toggle the class .focus.
                  if ( 'li' === self.tagName.toLowerCase() ) {
                    if ( -1 !== self.className.indexOf( 'focus' ) ) {
                      self.className = self.className.replace( ' focus', '' );
                    } else {
                      self.className += ' focus';
                    }
                  }

                  self = self.parentElement;
                }
              }
            } )();






            var cookieName = 'panelCookie'; // The cookie name
            var cookieLifetime = 10; // Cookie expiry in days
           
            /**
             * Set a cookie
             * @param cname - cookie name
             * @param cvalue - cookie value
             * @param exdays - expiry in days
             */
            var _setCookie = function (cname, cvalue, exdays) {
              var d = new Date();
              d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
              var expires = "expires=" + d.toUTCString();
              document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            };
           
            /**
             * Get a cookie
             * @param cname - cookie name
             * @returns string
             */
            var _getCookie = function (cname) {
              var name = cname + "=";
              var ca = document.cookie.split(';');
              for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                  c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
                }
              }
              return "";
            };
           
            /**
             * Should the cookie popup be shown?
             */
            var _shouldShowPopup = function () {
              if (_getCookie(cookieName)) {
                return false;
              } else {
                return true;
              }
            };
           
            // Show the cookie popup on load if not previously accepted
            if (_shouldShowPopup()) {
              setTimeout(function(){
                $('#contactslideOut').addClass('showSlideOut');
              }, 3000);
            }
           
            // Modal dismiss btn - consent
            $('#contactslideOut .slideOutTab').on('click', function () {
              _setCookie(cookieName, 1, cookieLifetime);
            });




        });


        // $('.hamburger').click( function() {
        //   $('.hamburger').toggleClass('is-active');
        //   $('.mobile-navigation').toggleClass('is-active');
        //   $('body').toggleClass("bodyfixed");
        // });

        // $('.hamburger.is-active').click( function() {
        //   $('.mobile-navigation').toggleClass('is-active');
        //   $('.hamburger').toggleClass('is-active');
        //   $('body').toggleClass("bodyfixed");
        // });

        if ($(window).width() > 991) {
          $('.dropdown > a').click(function(){
              location.href = this.href;
          });
        };


        $('.page-scroll').bind('click', function(event) {
            var $anchor = $(this);
            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top
            }, 800, 'easeInOutExpo');
            event.preventDefault();
        });


        $(".video-container").fitVids();


        $(document).ready(function(){
            $('.icon-text-grid .icon-grid-items .card .item-description').matchHeight({byRow:false});
            $('.three-col-icon-text-grid .icon-text-items .icon').matchHeight({byRow:false});
            $('.service-description .icon-grid-items .item-description').matchHeight({byRow:false});
            $('.swiper-news-container .swiper-slide .card-news').matchHeight({byRow:false});
        });
        $(window).resize(function() {
            $('.icon-text-grid .icon-grid-items .card .item-description').matchHeight({byRow:false});
            $('.three-col-icon-text-grid .icon-text-items .icon').matchHeight({byRow:false});
            $('.service-description .icon-grid-items .item-description').matchHeight({byRow:false});
            $('.swiper-news-container .swiper-slide .card-news').matchHeight({byRow:false});
        });



         $(".wpcf7 .wpcf7-text").focus(function(){
           $(this).parent().addClass("focus");
          }).blur(function(){
           $(this).parent().removeClass("focus");
          })



        // news grid carousel
        var swiper = new Swiper('.swiper-news-container', {
          slidesPerView: 2,
          slidesPerGroup: 2,
          lazy: true,
          loop: false,
          spaceBetween: 30,

          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 15
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 1,
              spaceBetween: 15
            },
            // when window width is >= 640px
            768: {
              slidesPerView: 1,
              spaceBetween: 30
            },
            998: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 30
            },
            1200: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 30
            }
          },

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-news-button-next',
            prevEl: '.swiper-news-button-prev',
          },
          
        });




        this.$slideOut = $('#contactslideOut');

        // Slideout show
        this.$slideOut.find('.slideOutTab').on('click', function() {
          $("#contactslideOut").toggleClass('showSlideOut');
        });

    

        // Select2 formatting
        function format (item) {
          return $(item.element).html();
        }
        // Select2 Targeting
        $('.orderby').select2({
            formatResult: format,
            formatSelection: format,
            escapeMarkup: function (text) { return text; },
            minimumResultsForSearch: Infinity
        });

        $('.woocommerce-perpage select').select2({
            formatResult: format,
            formatSelection: format,
            escapeMarkup: function (text) { return text; },
            minimumResultsForSearch: Infinity
        });


        

        // By default submit is disabled unless user adds search term (prevents empty searches)
        $('.btn-search-holder').prop('disabled', true);
        $('.input-text-rounded').keyup(function() {
          if($(this).val().length !=0 ) {
            $('.btn-search-holder').prop('disabled', false);
          } else {
            $( ".input-text-rounded").focus();
              $('.btn-search-holder').prop('disabled', true);
              e.preventDefault();
          }
        });



        $(document).on('change', '.variation-radios input', function() {
          $('select[name="'+$(this).attr('name')+'"]').val($(this).val()).trigger('change');
        });
        $(document).on('woocommerce_update_variation_values', function() {
          $('.variation-radios input').each(function(index, element) {
            $(element).removeAttr('disabled');
            var thisName = $(element).attr('name');
            var thisVal  = $(element).attr('value');
            if($('select[name="'+thisName+'"] option[value="'+thisVal+'"]').is(':disabled')) {
              $(element).prop('disabled', true);
            }
          });
        });



        $('.cbp-link').click(function(e) {
            e.preventDefault();
            window.open($(this).attr('href'), 'ShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            return false;
        });





        // accreditations carousel
        var swiper = new Swiper('.swiper-accreditations-container', {
          slidesPerView: 1,
          slidesPerGroup: 1,
          lazy: true,
          loop: false,
          spaceBetween: 30,

          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 15
            },
            // when window width is >= 640px
            768: {
              slidesPerView: 4,
              spaceBetween: 30
            },
            992: {
              slidesPerView: 4,
               slidesPerGroup: 1,
              spaceBetween: 50
            },
            1200: {
              slidesPerView: 6,
               slidesPerGroup: 1,
              spaceBetween: 80
            }
          },

        });



        var swiper = new Swiper('.swiper-service-accreditations-container', {
          slidesPerView: 1,
          slidesPerGroup: 1,
          lazy: true,
          loop: false,
          spaceBetween: 10,
        });



        // specialists carousel
        var swiper = new Swiper('.swiper-specialists-container', {
          slidesPerView: 1,
          slidesPerGroup: 1,
          lazy: true,
          loop: false,
          spaceBetween: 30,

          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 15
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 1,
              spaceBetween: 15
            },
            // when window width is >= 640px
            768: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            992: {
              slidesPerView: 4,
               slidesPerGroup: 1,
              spaceBetween: 30
            },
            1200: {
              slidesPerView: 4,
               slidesPerGroup: 1,
              spaceBetween: 30
            }
          },

          pagination: {
            el: '.swiper-specialists-pagination',
            clickable: true,
          },
          // Navigation arrows
          navigation: {
            nextEl: '.swiper-specialists-button-next',
            prevEl: '.swiper-specialists-button-prev',
          },
          
        });
        





    /* eslint-enable */


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js